/**
 * @fileoverview POST handler for the "/data_objects/:type_name/:object_id/object_relationships" endpoint.
 * Creates CO->CO relationship edges from the anchor object in the given direction.
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameObjectIdObjectRelationships } from "./constants";
import type {
  PostCustomObjectsTypeNameObjectIdObjectRelationshipsParams,
  PostCustomObjectsTypeNameObjectIdObjectRelationshipsResponse,
} from "./types";

export const postCustomObjectsTypeNameObjectIdObjectRelationships = reactQueryMutationAdapter(
  customObjectsTypeNameObjectIdObjectRelationships,
  ({
    appGroupId,
    typeName,
    objectId,
    direction,
    targetTypeName,
    relKind,
    targetObjectIds,
  }: PostCustomObjectsTypeNameObjectIdObjectRelationshipsParams): Promise<PostCustomObjectsTypeNameObjectIdObjectRelationshipsResponse> => {
    return fetch<PostCustomObjectsTypeNameObjectIdObjectRelationshipsResponse>(
      `/data_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(objectId)}/object_relationships`,
      "POST",
      {
        app_group_id: appGroupId,
        direction,
        target_type_name: targetTypeName,
        rel_kind: relKind,
        target_object_ids: targetObjectIds,
      },
      {},
      { propagateFetchRequestError: false }
    );
  }
);
